import { Fragment } from 'react';
import { BookingSummaryVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import { DetailsLink } from '@/features/dashboard/bookingChanges/routes/detailsLinks.ts';
import BookingStateHeader from './BookingStateHeader';
import BookingStateMoneyRow from './BookingStateMoneyRow';
import BookingStateStatusRow from './BookingStateStatusRow';
import { InfoCard, InfoCardBody } from '@/components/ui/InfoCard.tsx';

interface BookingStateCardProps extends React.HTMLAttributes<HTMLDivElement> {
  summary: BookingSummaryVm;
  /** Dokąd prowadzi kod rezerwacji; adres zna rodzic, nie karta. */
  bookingLink: DetailsLink;
}

/**
 * Karta „Stan rezerwacji” — panel boczny w trybie podglądu. Wartość, wpłaty
 * i saldo rezerwacji, do której należy oglądana osoba.
 */
const BookingStateCard = ({
  summary,
  bookingLink,
  ...props
}: BookingStateCardProps) => (
  <InfoCard {...props}>
    <BookingStateHeader summary={summary} bookingLink={bookingLink} />

    <InfoCardBody>
      {/* Saldo jest per waluta, więc trójka wierszy powtarza się dla każdej
          z nich; kwota niesie symbol, więc etykiety nie trzeba różnicować. */}
      {summary.balances.map((balance, index) => (
        <Fragment key={balance.totalValue.currency}>
          <BookingStateMoneyRow
            divided={index > 0}
            label="Wartość"
            value={balance.totalValue}
          />
          <BookingStateMoneyRow
            label="Wpłacono"
            value={balance.paid}
            strong={false}
          />
          {/* Saldo ujemne to nadpłata klienta, a nie „do zapłaty −200 zł" —
              kwota do zwrotu należy mu się z powrotem, więc i nazwa, i znak
              muszą to mówić wprost. */}
          {balance.due.amount < 0 ? (
            <BookingStateMoneyRow
              label="Nadpłata"
              value={{ ...balance.due, amount: -balance.due.amount }}
            />
          ) : (
            <BookingStateMoneyRow label="Do zapłaty" value={balance.due} />
          )}
        </Fragment>
      ))}
      <BookingStateStatusRow summary={summary} />
    </InfoCardBody>
  </InfoCard>
);

export default BookingStateCard;
